export enum HoursMutations {
  RESET = "RESET",
  SET_SELECTED = "SET_SELECTED",
  SET_HOUR = "SET_HOUR",
  SET_HOURS = "SET_HOURS",
  APPROVE_HOUR = "APPROVE_HOUR",
  ADD = "ADD",
}
